import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349fedb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (item) => {
    return (_openBlock(), _createBlock(_component_el_row, {
      gutter: 20,
      class: "case-item",
      key: item.id
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 8,
          offset: 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "case-link",
              to: { path: '/successfulCase', query: { id: item.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: item.pic,
                  class: "pic"
                }, null, 8, _hoisted_1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 16,
          class: "info"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "case-link",
              to: { path: '/successfulCase', query: { id: item.id } }
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, _toDisplayString(item.name), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(item.brief), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 2
    }, 1024))
  }), 128))
}